/* ==========================================================================
   Slider cart upsell.

   One button, one job: put the upsell variant in the cart and let Dawn's own
   cart-drawer repaint itself. The section list comes from the drawer so the
   cart icon bubble updates at the same time as the drawer body.
   ========================================================================== */

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cart-upsell-add]');
  if (!button) return;

  event.preventDefault();
  if (button.getAttribute('aria-disabled') === 'true') return;

  const drawer = document.querySelector('cart-drawer');
  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.setAttribute('aria-disabled', 'true');

  const body = new FormData();
  body.append('id', variantId);
  body.append('quantity', 1);
  if (drawer) {
    body.append(
      'sections',
      drawer.getSectionsToRender().map((section) => section.id)
    );
    body.append('sections_url', window.location.pathname);
  }

  const cartAddUrl = (window.routes || {}).cart_add_url || '/cart/add';

  fetch(cartAddUrl, {
    method: 'POST',
    headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
    body,
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) throw new Error(response.description || response.message);
      if (drawer) {
        drawer.renderContents(response);
      } else {
        window.location = (window.routes || {}).cart_url || '/cart';
      }
    })
    .catch((error) => {
      console.error(error);
      button.removeAttribute('aria-disabled');
    });
});
